import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, contasBancarias } = obj
  // console.log('actions.js - Line 6: ' + JSON.stringify(contasBancarias))

  // contasBancarias.banco = contasBancarias.banco.banco
  // contasBancarias.logo = contasBancarias.logo.arquivo
  // console.log('actions.js - Line 10: ' + contasBancarias.banco.banco)

  const response = await http[verb]('/contasBancarias', contasBancarias)

  if (response !== null) {
    contasBancarias.id = response.data.data.id
    update(context, { ...contasBancarias })
    return Promise.resolve()
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/contasBancarias/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const getBanks = async (context) => {
  const response = await http.get('https://www.febraban.org.br/associados/utilitarios/bancos.asp')
  if (response !== null) {
    let banksObject = []
    let html = this.$(response.data)
    let banksHtml = html.find('tbody tr:nth-child(n+5)')

    banksHtml.each((index, element) => {
      let objectAux = {}
      let columns = this.$(element).find('td:nth-child(-n + 2)')

      columns.each((index, element) => {
        if (index === 0) {
          objectAux['code'] = this.$.trim(this.$(element).text()).replace(/[-!$%^&*()_+|~=`{}\]:";<>?,.@#]/gm, '')

          return true
        }

        objectAux['name'] = this.$.trim(this.$(element).text())
      })

      if (!objectAux.code) {
        return true
      }

      banksObject.push(objectAux)
    })

    return Promise.resolve(banksObject)
  }
}

const fetch = async ({ commit }) => {
  const response = await http.get('/contasBancarias')
  if (response !== null) {
    const contasBancarias = response.data
    commit('SET_LIST', contasBancarias)
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { contasBancarias: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/contasBancarias/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove,
  getBanks
}



// WEBPACK FOOTER //
// ./src/features/admin/contasBancarias/store/actions.js